import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "w-full text-white p-3 bg-black-header flex justify-between flex-grow-0" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"icon xr-main-net mr-2 inline-block\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span><span class=\"path4\"></span></span>", 1)
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = {
  key: 0,
  class: "p-3 border-t border-black-border bg-black-header w-full flex-grow text-md"
}
const _hoisted_6 = {
  key: 0,
  class: "text-danger-primary bg-danger-background text-sm p-3 mb-3"
}
const _hoisted_7 = { class: "mb-3 text-gray-text" }
const _hoisted_8 = { class: "w-full md:w-80 lg:w-full xl:w-80 text-sm mb-5" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 text-xs w-28" }, "Token Name:", -1)
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 text-xs w-28" }, "Symbol:", -1)
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 text-xs w-28" }, "Type:", -1)
const _hoisted_15 = { class: "truncate overflow-ellipsis" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 text-xs w-28" }, "Circulation Supply:", -1)
const _hoisted_18 = { class: "font-bold text-green-600 text-md" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "p-3 border-t border-black-border bg-black-header w-full flex-grow text-md"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text mb-1" }, "Circulation Supply", -1)
const _hoisted_22 = { class: "text-green-600 font-bold my-2 mb-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text my-1" }, "Assigned Asset ID", -1)
const _hoisted_24 = { class: "text-white my-2 mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text mb-2" }, "Linked Namespaces", -1)
const _hoisted_26 = {
  key: 0,
  class: "mr-1 mb-1 inline-block max-w-full text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tokensConfirmCreateTokenModal = _resolveComponent("tokensConfirmCreateTokenModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center", !_ctx.userData.mainnetWalletAddress?'opacity-50':''])
      }, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, "Token in " + _toDisplayString(_ctx.mainnetLabel), 1)
      ], 2)
    ]),
    (_ctx.userData.mainnetWalletAddress && _ctx.mainnetTokenData == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.isInsufficientBalance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, "This account has insufficient XPX. Balance of minumum 1,500 xpx is required in your " + _toDisplayString(_ctx.mainnetLabel) + " wallet to create token.", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, "Create token in " + _toDisplayString(_ctx.mainnetLabel), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_ctx.tokenName), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, _toDisplayString(_ctx.symbol?_ctx.symbol:'-'), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.typeLabel) + " (" + _toDisplayString(_ctx.tokenType) + ")", 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(this.supply?_ctx.Helper.convertToCurrency(this.supply):this.supply), 1)
            ])
          ]),
          _createTextVNode(_toDisplayString(_ctx.mainnetTokenData) + " ", 1),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createMainnetTokenQr())),
            disabled: _ctx.disableCreate
          }, "Create Token", 8, _hoisted_19)
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData.mainnetWalletAddress && _ctx.mainnetTokenData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.mainnetTokenData.formattedAmount), 1),
          _hoisted_23,
          _createElementVNode("h6", _hoisted_24, _toDisplayString(_ctx.mainnetTokenData.tokenId), 1),
          _hoisted_25,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainnetTokenData.names, (name, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "badge-gray mr-1 mb-1 inline-block truncate max-w-full",
              key: index
            }, _toDisplayString(name), 1))
          }), 128)),
          (!_ctx.mainnetTokenData.names)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, "None"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_tokensConfirmCreateTokenModal, {
      networkLabel: "Mainnet",
      onCloseModel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isQRModalShow = false)),
      onConfirmedButtonPressed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createMainnetToken())),
      isQRModalShow: _ctx.isQRModalShow,
      previewImage: _ctx.tokenImage,
      tokenName: _ctx.tokenName,
      symbol: _ctx.symbol,
      tokenType: _ctx.tokenType,
      supply: _ctx.supply,
      qr: _ctx.qr,
      showUploadingLoader: _ctx.showUploadingLoader,
      isDisabledModalConfirmSubmitButton: _ctx.isDisabledModalConfirmSubmitButton
    }, null, 8, ["isQRModalShow", "previewImage", "tokenName", "symbol", "tokenType", "supply", "qr", "showUploadingLoader", "isDisabledModalConfirmSubmitButton"])
  ]))
}